import { useQuery, useQueryClient } from '@tanstack/react-query'

import {
  GET_ACTIVATION_SCHEDULES_BY_REGULATION_OBJECT_API_ID,
  getActivationSchedulesByRegulationObject,
} from '@/features/activationPlan/endpoints/activationSchedules'
import type { ActivationSchedulesByRegulationObject } from '@/features/activationPlan/types'

type UseActivationSchedulesByRegulationObjectQueryParams = {
  portfolioCode: string
  deliveryDay: string
}

export function useActivationSchedulesByRegulationObjectQuery({
  portfolioCode,
  deliveryDay,
}: UseActivationSchedulesByRegulationObjectQueryParams) {
  const query = useQuery<ActivationSchedulesByRegulationObject>({
    queryKey: [GET_ACTIVATION_SCHEDULES_BY_REGULATION_OBJECT_API_ID, portfolioCode, deliveryDay],
    queryFn: async () => getActivationSchedulesByRegulationObject({ portfolioCode, deliveryDay }),
    enabled: Boolean(portfolioCode && deliveryDay),
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}

export function useInvalidateActivationSchedulesByRegulationObjectQuery() {
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries({ queryKey: [GET_ACTIVATION_SCHEDULES_BY_REGULATION_OBJECT_API_ID] })
  }
}
